import { http, HttpResponse } from 'msw'
import { StatusCodes } from 'http-status-codes'

import { allManagers } from 'app/mocks/data/park/managers'

import { api } from 'app/utils/constants'

import { Client, ClientPayload } from 'app/types/park/client'

export const createClient = http.post(
    `${process.env.REACT_APP_API_ADDRESS}/${api.park.clients.LIST}`,
    async ({ request }) => {
        const payload = await request.json()
        const payloadParsed = ClientPayload.safeParse(payload)

        // Wrong data
        if (!payloadParsed.success) {
            return HttpResponse.json(undefined, {
                status: StatusCodes.UNPROCESSABLE_ENTITY,
            })
        }

        return HttpResponse.json<Client>(
            {
                id: 999,
                ...payloadParsed.data,
                client: allManagers.find(
                    (manager) => manager.id === payloadParsed.data.client,
                ),
            },
            {
                status: StatusCodes.CREATED,
            },
        )
    },
)
